import { TbBattery4 } from 'react-icons/tb';
import api from '../config/api';

const API_URL = process.env.REACT_APP_API_URL;

export const spacesStatus = async () => {
  try {
    const response = await api.get(`${API_URL}SpacesStatus/global-stats`);
    return response.data.data;
  } catch (error) {}
};
export const fetchWorkModsByUser = async id => {
  try {
    const response = await api.get(`${API_URL}Operation/user/${id}/weekly-work-modes`);
    return response.data.data;
  } catch (error) {}
};
export const getALLOperations = async (startDate, endDate) => {
  try {
    const response = await api.get(`${API_URL}Operation/Alloperations/${startDate}/${endDate}`);

    return response.data.data;
  } catch (error) {
    console.error('Error fetching operations:', error);
    return []; // Retourne un tableau vide en cas d'erreur
  }
};

export const ReservationWeek = async (startDate, endDate) => {
  try {
    const response = await api.get(`${API_URL}Operation/reservation-count/${startDate}/${endDate}`);
    return response.data.data;
  } catch (error) {}
};
export const OperationToday = async () => {
  try {
    const response = await api.get(`${API_URL}Operation/operations-today`);
    return response.data.data;
  } catch (error) {}
};

export const OperationDepartement = async (startDate, endDate) => {
  try {
    const response = await api.get(
      `${API_URL}Operation/operationByDepartement/${startDate}/${endDate}`
    );
    return response.data.data;
  } catch (error) {}
};

export const ReservationCheckin = async (startDate, endDate) => {
  try {
    const response = await api.get(
      `${API_URL}Operation/getReseravtionCheckin/${startDate}/${endDate}`
    );
    return response.data.data;
  } catch (error) {}
};
export const getReservationCountPerDay = async (startDate, endDate) => {
  try {
    const response = await api.get(`${API_URL}Operation/reservation-count/${startDate}/${endDate}`);
    return response.data.data;
  } catch (error) {}
};
export const OperationPeriod = async (startDate, endDate) => {
  try {
    const response = await api.get(`${API_URL}Operation/operations/${startDate}/${endDate}`);
    return response.data.data;
  } catch (error) {}
};
export const CombinedStatus = async date => {
  try {
    const response = await api.get(`${API_URL}Operation/users-with-untraced/${date}`);
    return response;
  } catch (error) {}
};

export const teamWorkspaces = async () => {
  try {
    const response = await api.get(`${API_URL}Operation/team-workspaces-utilization`);
    return response;
  } catch (error) {}
};
export const zoneByFloor = async (startDate, endDate) => {
  try {
    const response = await api.get(`${API_URL}Operation/zones-by-floor/${startDate}/${endDate}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching zones by floor for date range:', error);
    throw error;
  }
};
export const WorkModesDistribution = async date => {
  try {
    const response = await api.get(`${API_URL}Operation/work-mode-distribution/${date}`);
    return response;
  } catch (error) {}
};
export const getZoneBookingOccupationPerDate = async (startDate, endDate) => {
  try {
    const response = await api.get(
      `${API_URL}Operation/getZoneBookingOccupationPerDate/${startDate}/${endDate}`
    );
    return response.data.data;
  } catch (error) {
    console.error('Error fetching zone booking occupation for date range:', error);
    throw error;
  }
};
export const getFutureOccupation = async () => {
  try {
    const response = await api.get(`${API_URL}Operation/getFutureOccupation`);
    return response.data;
  } catch (error) {}
};
export const getFutureOccupationByfloor = async () => {
  try {
    const response = await api.get(`${API_URL}Operation/getFutureOccupationByfloor`);
    return response.data;
  } catch (error) {}
};
